import React from "react";
import { Card, CardContent } from "@mui/material";

const CardHeaderDashboard = (props) => {
  const { label, value = 0, icon, backgroundColor = "#6160DC" } = props;
  return (
    <Card>
      <CardContent>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                color: "#8E8EA1",
              }}
            >
              {label}
            </div>
            <b style={{ fontSize: "2em" }}>{value}</b>
          </div>
          <div
            style={{
              width: "4em",
              height: "4em",
              background: backgroundColor,
              color: "white",
              borderRadius: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CardHeaderDashboard;
